var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBeatportYellowLogoMobile = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 40,
    viewBox: "0 0 33 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 28.3763C33 34.803 27.7327 40 21.0629 40C14.3931 40 9.19558 34.9328 9.19558 28.3763C9.19558 25.2928 10.395 22.5676 12.2988 20.5222L4.23288 28.3763L0 24.2546L9.10038 15.4859C10.3315 14.287 10.9662 12.7236 10.9662 11.0057V0H16.9315V11.0057C16.9315 14.3797 15.7004 17.2408 13.2952 19.5767L13.0287 19.8362C15.1292 17.9515 17.9977 16.8145 21.0629 16.8145C27.8342 16.8145 33 22.0423 33 28.3702M27.5994 28.3702C27.5994 24.9282 24.6675 22.135 21.0629 22.135C17.4583 22.135 14.5962 25.0579 14.5962 28.3702C14.5962 31.6824 17.4646 34.6671 21.0629 34.6671C24.6612 34.6671 27.5994 31.7133 27.5994 28.3702Z",
    fill: "#FAC300"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBeatportYellowLogoMobile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/beatport-yellow-logo-mobile.f78a9e3ccb6e9ef86c051112c71afb60.svg";